import { styled } from '@mui/system';
import { COLORS } from './colors';
import theme from '../../../components/App/theme';

export const MetricCards = styled('div')(({ theme: { spacing } }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: spacing(2),
  margin: `${spacing(6)} 0`,
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
}));

interface MetricCardContainerProps {
  isAnchor: boolean;
}
export const MetricCardContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isAnchor',
})<MetricCardContainerProps>(({ theme: { spacing }, isAnchor }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  padding: spacing(1.5),
  backgroundColor: COLORS.black[80],
  borderRadius: spacing(1.5),
  columnGap: spacing(1.5),
  transition: 'all ease-out .05s',
  '&:hover': {
    backgroundColor: isAnchor ? COLORS.black[70] : COLORS.black[80],
    boxShadow: isAnchor ? `0 0 0 3px ${COLORS.brand[100]}` : 'none',
    transition: 'all ease-in-out .15s',
  },
  '& svg': {
    width: 35,
    height: 35,
  },
}));

export const MetricCardAnchor = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  '&:hover': {
    cursor: 'pointer',
  },
});

export const MetricCardContent = styled('div')({
  backgroundColor: 'transparent',
});

export const MetricCardNumber = styled('div')({
  fontWeight: 400,
  fontSize: 20,
  lineHeight: '135%',
});
export const MetricCardTotal = styled('span')({
  fontWeight: 400,
  fontSize: 16,
  lineHeight: '135%',
});

export const MetricCardLabel = styled('div')({
  fontWeight: 500,
  fontSize: 12,
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  color: COLORS.white[50],
  lineHeight: '135%',
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  '& svg': {
    position: 'relative',
  },
});
